var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file    每页项目数选择组件
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/* global document */

var PerPage = function (_Component) {
    _inherits(PerPage, _Component);

    function PerPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PerPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PerPage.__proto__ || Object.getPrototypeOf(PerPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            dropDown: false
        }, _this.perPage = function (e) {
            e.stopPropagation();
            _this.setState(function (_ref2) {
                var dropDown = _ref2.dropDown;
                return {
                    dropDown: !dropDown
                };
            });
        }, _this.bc = function () {
            _this.setState(function () {
                return {
                    dropDown: false
                };
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PerPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var body = document.body || document.documentElement;
            var pageRowNumber = this.pageRowNumber;
            var pageSelection = this.pageSelection;
            body.addEventListener('click', this.bc, false);
            if (pageRowNumber) {
                pageRowNumber.addEventListener('click', this.perPage, false);
            }
            if (pageSelection) {
                pageSelection.addEventListener('click', this.perPage, false);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var body = document.body || document.documentElement;
            var pageRowNumber = this.pageRowNumber;
            var pageSelection = this.pageSelection;
            body.removeEventListener('click', this.bc, false);
            if (pageRowNumber) {
                pageRowNumber.removeEventListener('click', this.perPage, false);
            }
            if (pageSelection) {
                pageSelection.removeEventListener('click', this.perPage, false);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                perPage = _props.perPage,
                sizeStyle = _props.sizeStyle,
                onChange = _props.onChange,
                perList = _props.perList;

            var dropDown = this.state.dropDown;
            var perDownClass = classnames({
                'per-down': true,
                disNone: !dropDown
            });
            return React.createElement(
                'li',
                { className: 'margin28', style: sizeStyle },
                React.createElement(
                    'div',
                    {
                        style: {
                            cursor: 'default'
                        }
                    },
                    '\u6BCF\u9875\u663E\u793A'
                ),
                React.createElement(
                    'div',
                    {
                        className: 'perPage',
                        ref: function ref(pageRowNumber) {
                            _this2.pageRowNumber = pageRowNumber;
                        }
                    },
                    React.createElement('input', { type: 'text', value: perPage, readOnly: 'readonly' })
                ),
                React.createElement('div', {
                    className: classnames({
                        dropdown: !dropDown,
                        dropup: dropDown
                    }),
                    ref: function ref(pageSelection) {
                        _this2.pageSelection = pageSelection;
                    }
                }),
                React.createElement(
                    'ul',
                    {
                        className: perDownClass,
                        onClick: function onClick(e) {
                            onChange(e);
                        }
                    },
                    perList
                )
            );
        }
    }]);

    return PerPage;
}(Component);

PerPage.propTypes = {
    perPage: PropTypes.number,
    sizeStyle: PropTypes.object,
    onChange: PropTypes.func,
    perList: PropTypes.node
};
export default PerPage;